<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>

      <div class="table-responsive">
        <table class="table">
          <thead class="thead-light">
          <tr>
            <th>#</th>
            <th>Group</th>
            <th>Product</th>
            <th>Type</th>
            <th>Amount</th>
            <th>Amount Title</th>
            <th>Desc</th>
            <th>Best.-Nr.</th>
            <th>Date</th>
            <th class="d-print-none">Action</th>
          </tr>
          </thead>


          <tbody>
          <tr v-for="(row,index) in items" :key="index">
            <td>{{++index}}</td>
            <td>
              {{row.group}}
            </td>
            <td>
              {{row.product}}
            </td>
            <td>
              {{row.type}}
            </td>
            <td>
              {{row.amount}}
            </td>
            <td>
              {{row.amount_title}}
            </td>
            <td v-html="row.description"></td>
            <td>
              <template v-if="row.type === 'output'">
                <router-link class="text-primary font-weight-bold"
                             :to="{name:'OrderDetails',params:{'orderid':row.orderId}}">{{row.orderTrackingNumber}}</router-link>
              </template>
            </td>
            <td>
              {{row.date}}
            </td>
            <td class="d-print-none">
              <b-button variant="danger" @click="deleteItem(row.id)">delete</b-button>
            </td>
          </tr>
          </tbody>

        </table>
      </div>
    </div>
</template>

<script>
    import Http from '../../../Services/HttpService/HttpService'
    import Notification from '../../../Services/Notification/Nottification'
    import {EventBus} from "../../../Services/Eventbus/event-bus";

    export default {
        name: "LogItems",
        props: {
            items: {
                type: Array,
                default: null
            }
        },
        data() {
            return {
                fields: [
                    {
                        key: 'group',
                        label: 'group'
                    },
                    {
                        key: 'product',
                        label: 'product'
                    },
                    {
                        key: 'type',
                        label: 'type'
                    },
                    {
                        key: 'amount',
                        label: 'amount'
                    },
                    {
                        key: 'amount_title',
                        label: 'amount title'
                    },
                    {
                        key: 'description',
                        label: 'description'
                    },
                    {
                        key: 'date',
                        label: 'date'
                    },
                    {
                        key: 'action',
                        label: 'action'
                    },

                ]
            }
        },
        methods: {
            deleteItem(id) {
                if (confirm(this.$t('alertText'))) {
                    this.$Progress.start();
                    Http.get(Http.apiurlV2() + 'stock/delete/log/' + id)
                        .then(response => {
                            this.$Progress.finish();
                            if (response.data.status_code === Http.ok()) {
                                Notification.success(response.data.message);
                                EventBus.$emit('refreshData', 'yes')
                            }
                        })
                        .catch(error => {
                            this.$Progress.finish();
                        })
                }
            },
        }
    }
</script>

<style scoped>

</style>